module.exports = __webpack_public_path__ + "static/media/AU.ed0c96d2.png";